// Khmer -> English UI dictionary, keyed by the original Khmer source string.
// Missing entries fall back to the original Khmer text — see LanguageContext.
import { GUIDE_EN } from "../guide/guides";

export const DICT = {
  ...GUIDE_EN,
  // --- Guided tour ---
  "រំលង": "Skip",
  "ថយក្រោយ": "Back",
  "បន្ទាប់": "Next",
  "ណែនាំការប្រើប្រាស់": "User guide",
  "ស្វែងរកមន្ត្រី": "Search officers",
  "វាយឈ្មោះ ឬលេខកូដមន្ត្រី ដើម្បីស្វែងរកក្នុងបញ្ជី។": "Type a name or officer code to find someone in the list.",
  "ត្រងតាមស្ថានភាព": "Filter by status",
  "ជ្រើសរើសស្ថានភាព ដូចជា កំពុងបម្រើការ ចូលនិវត្តន៍ ឬបានលាឈប់ ដើម្បីបង្ហាញតែមន្ត្រីក្នុងស្ថានភាពនោះ។": "Pick a status such as Active, Retired or Resigned to show only officers in that status.",
  "ត្រងតាមនាយកដ្ឋាន": "Filter by department",
  "ជ្រើសរើសនាយកដ្ឋាន ដើម្បីបង្ហាញតែមន្ត្រីនៅនាយកដ្ឋាននោះ។": "Pick a department to show only the officers in it.",
  "បន្ថែមមន្ត្រីថ្មី": "Add a new officer",
  "ចុចប៊ូតុងនេះដើម្បីបង្កើតព័ត៌មានមន្ត្រីថ្មី។ ប៊ូតុងនេះបង្ហាញតែអ្នកដែលមានសិទ្ធិបង្កើតប៉ុណ្ណោះ។": "Click this button to create a new officer record. It only appears for people allowed to create officers.",
  "បញ្ជីមន្ត្រី": "Officer list",
  "តារាងបង្ហាញលេខកូដ ឈ្មោះ តំណែង ការិយាល័យ នាយកដ្ឋាន និងស្ថានភាពរបស់មន្ត្រីម្នាក់ៗ។": "The table shows each officer's code, name, position, office, department and status.",
  "ចុចរូបភ្នែកដើម្បីមើលលម្អិត រូបខ្មៅដៃដើម្បីកែប្រែ និងរូបធុងសំរាមដើម្បីលុប។ ក្នុងផ្ទាំងលម្អិត អ្នកអាចផ្អាក ឬបើកដំណើរការមន្ត្រីបាន។": "Click the eye to view details, the pencil to edit and the bin to delete. In the details window you can also suspend or activate an officer.",
  "បញ្ចូលលេខកូដមន្ត្រីមិនឲ្យស្ទួនគ្នា ដោយប្រើតែអក្សរឡាតាំង លេខ និងសញ្ញា - ឬ _ ប៉ុណ្ណោះ។": "Enter a unique officer code using only Latin letters, digits, - or _.",
  "ជ្រើសរើសនាយកដ្ឋានជាមុនសិន បន្ទាប់មកជ្រើសរើសការិយាល័យ និងតំណែងក្នុងនាយកដ្ឋាននោះ។": "Choose the department first, then pick an office and a position in that department.",
  "បំពេញគ្រប់ប្រអប់ដែលមានសញ្ញា * ហើយចុចរក្សាទុក។ ប្រសិនបើខ្វះ ប្រអប់នោះនឹងប្រែជាពណ៌ក្រហម។": "Fill in every field marked * and click Save. A missing field turns red.",
  // --- Bulk pass: Meeting, Staff, ContractOfficer, Documents, Announcements,
  // Approvals, Notifications, Roles, Settings, Reports, ActivityLog, Rooms,
  // ProfileModal (buttons, placeholders, confirm messages, toasts, forms) ---
  "— (ឯកសារបច្ចុប្បន្ន)": "— (current file)",
  "— ជ្រើសរើសឯកសារថ្មីដើម្បីជំនួស": "— choose a new file to replace it",
  "— មិនចាំបាច់ —": "— not required —",
  "+ បន្ថែមការប្រកាស": "+ Add announcement",
  "+ បន្ថែមកំណត់ហេតុប្រជុំ": "+ Add meeting minutes",
  "+ បន្ថែមតួនាទីថ្មី": "+ Add new role",
  "+ បន្ថែមតំណែង": "+ Add position",
  "+ បន្ថែមនាយកដ្ឋាន": "+ Add department",
  "+ បន្ថែមបន្ទប់": "+ Add room",
  "+ បន្ថែមប្រជុំ": "+ Add meeting",
  "+ បន្ថែមប្រភេទ": "+ Add type",
  "+ បន្ថែមមន្ត្រី": "+ Add staff",
  "+ បន្ថែមមន្ត្រីកិច្ចសន្យា": "+ Add contract staff",
  "+ បន្ថែមឯកសារ": "+ Add document",
  "+ បន្ថែមអ្នកគ្រប់គ្រង": "+ Add manager",
  "+ បន្ថែមអ្នកប្រើប្រាស់": "+ Add user",
  "+ បន្ថែមអ្នករួមចំណែក": "+ Add participant",
  "+ ស្នើសុំការអនុម័ត": "+ Request approval",
  "+ ស្នើសុំអនុម័ត": "+ Request approval",
  "· បង្ហាញតែរបស់ខ្ញុំ": "· mine only",
  "JPG, PNG · អតិបរមា 5MB": "JPG, PNG · max 5MB",
  "PDF, Word, JPG, PNG (អតិបរមា 10MB)": "PDF, Word, JPG, PNG (max 10MB)",
  "កក់រួច": "Booked",
  "កត់ត្រាដោយ:": "Recorded by:",
  "កម្រិតវប្បធម៌": "Education level",
  "ការចូលចុងក្រោយ": "Last login",
  "ការពិពណ៌នាអំពីកិច្ចប្រជុំ...": "Description of the meeting...",
  "ការស្នើសុំនឹងត្រូវបញ្ជូនទៅប្រធានសម្រាប់អនុម័ត": "The request will be sent to a supervisor for approval",
  "កាលបរិច្ឆេទ": "Date",
  "កិច្ចការត្រូវបន្ត": "Action items",
  "កិច្ចសន្យានឹងផុតក្នុង": "Contract expires within",
  "កូដតំណែង": "Position code",
  "កូដនាយកដ្ឋាន": "Department code",
  "កូដបន្ទប់": "Room code",
  "កែប្រែកំណត់ហេតុ": "Edit minutes",
  "កែប្រែនៅ": "Edited at",
  "កែប្រែព័ត៌មាន": "Edit information",
  "ក្រុមទាំងអស់": "All groups",
  "កំណត់ត្រា": "Note",
  "កំណត់ត្រា (note)": "Note",
  "កំណត់សម្គាល់": "Remarks",
  "កំណត់សម្គាល់បន្ថែម...": "Additional remarks...",
  "កំណត់អ្នកប្រើប្រាស់ជាអ្នកគ្រប់គ្រងសម្រាប់នាយកដ្ឋាននីមួយៗ": "Assign a user as manager for each department",
  "កំពុងផ្ទុក URL...": "Loading URL...",
  "កំពុងផ្ទុកកាលវិភាគ...": "Loading schedule...",
  "កំពុងផ្ទុកសិទ្ធិដែលមានហើយ...": "Loading existing permissions...",
  "ខេត្ត/ក្រុង": "Province/City",
  "ខែ": "Month",
  "ខ្លឹមសារ": "Content",
  "ខ្លឹមសារ...": "Content...",
  "គ្មានការស្នើសុំ": "No requests",
  "គ្មានការស្នើសុំអនុម័ត": "No approval requests",
  "គ្មានតួនាទី": "No roles",
  "គ្មានតំណែង": "No positions",
  "គ្មានទិន្នន័យត្រូវនឹងតម្រង": "No data matches the filter",
  "គ្មាននាយកដ្ឋាន": "No departments",
  "គ្មានបន្ទប់ប្រជុំ": "No meeting rooms",
  "គ្មានប្រភេទ": "No types",
  "គ្មានសិទ្ធិ": "No permissions",
  "គ្មានឯកសារ": "No documents",
  "គ្មានអ្នកគ្រប់គ្រងសម្រាប់នាយកដ្ឋាននេះ": "No managers for this department",
  "គ្មានអ្នកប្រើ": "No users",
  "គ្មានអ្នកប្រើប្រាស់": "No users",
  "គ្មានអ្នករួមចំណែក": "No participants",
  "គ្រប់គ្រងតំណែងទាំងអស់ក្នុងអង្គភាព": "Manage all positions in the organization",
  "គ្រប់គ្រងនាយកដ្ឋានទាំងអស់ក្នុងអង្គភាព": "Manage all departments in the organization",
  "គ្រឿងបរិក្ខារ": "Facilities",
  "ចម្បង": "Primary",
  "ចុចដើម្បីជ្រើសរើសរូបភាព": "Click to choose an image",
  "ចុចដើម្បីជ្រើសរើសឯកសារ": "Click to choose a file",
  "ចុចដើម្បីបើក / ទាញយក": "Click to open / download",
  "ចុចដើម្បីមើលរូបពេញ": "Click to view full image",
  "ចំណងជើង *": "Title *",
  "ចំណងជើង...": "Title...",
  "ចំណងជើង:": "Title:",
  "ចំណងជើងការជូនដំណឹង": "Notification title",
  "ចំណងជើងប្រជុំ": "Meeting title",
  "ចំណាត់ថ្នាក់មុខងារ": "Job classification",
  "ចំនួនតួនាទី:": "Number of roles:",
  "ចំនួនសិទ្ធិ:": "Number of permissions:",
  "ឆ្នាំ": "Year",
  "ជម្រើសរបស់អ្នក": "Your selection",
  "ជាន់ ១ អគារ A...": "Floor 1, Building A...",
  "ជាន់ ១, អគារ A...": "Floor 1, Building A...",
  "ជួល / ផ្ទាល់ខ្លួន": "Rented / Owned",
  "ជួសជុល": "Under maintenance",
  "ជួសជុល / មិនទំនេរ": "Maintenance / Unavailable",
  "ជ្រើសតួនាទី...": "Select a role...",
  "ជ្រើសរើស តួនាទី": "Select role",
  "ជ្រើសរើសតម្រង": "Select filter",
  "ជ្រើសរើសនាយកដ្ឋាន": "Select department",
  "ជ្រើសរើសនាយកដ្ឋាន...": "Select department...",
  "ជ្រើសរើសប្រជុំដើម្បីមើលព័ត៌មាន": "Select a meeting to view details",
  "ជ្រើសរើសប្រភេទ...": "Select type...",
  "ជ្រើសរើសប្រភេទរបាយការណ៍ដែលអ្នកចង់ទាញយក": "Select the report type you want to download",
  "ជ្រើសរើសមន្ត្រី...": "Select staff...",
  "ជ្រើសរើសរូបភាព": "Choose image",
  "ជ្រើសរើសឯកសារ...": "Select document...",
  "ជ្រើសរើសឯកសារដែលត្រូវការអនុម័ត": "Select the document to be approved",
  "ជ្រើសសស្ថានភាព...": "Select status...",
  "ជ្រើសសេចក្តីប្រកាស": "Select announcement",
  "ជ្រើសសេចក្តីប្រកាស...": "Select announcement...",
  "ជ្រើសសេចក្តីប្រកាសខាងលើ ដើម្បីមើលស្ថានភាពការអាន": "Select an announcement above to view its read status",
  "ឈ្មោះខ្មែរ...": "Khmer name...",
  "ឈ្មោះតំណែង (ភាសាអង់គ្លេស)": "Position name (English)",
  "ឈ្មោះប្រភេទ": "Type name",
  "ឈ្មោះពេញ": "Full name",
  "ឈ្មោះពេញ EN": "Full name (EN)",
  "ឈ្មោះពេញ ខ្មែរ": "Full name (Khmer)",
  "ឈ្មោះពេញ អង់គ្លេស": "Full name (English)",
  "ឈ្មោះពេញឯកសារ": "Full document name",
  "ឈ្មោះពេញអង់គ្លេស": "Full name (English)",
  "ដកអ្នកគ្រប់គ្រងបានជោគជ័យ!": "Manager removed successfully!",
  "ដល់ថ្ងៃ": "To date",
  "ឋានន្តរស័ក្តិ": "Rank",
  "តួនាទី (សម្រាប់អ្នកជ្រើសរើសទាំងអស់)": "Role (applied to everyone selected)",
  "តួនាទី:": "Role:",
  "តួនាទីទាំងអស់": "All roles",
  "តើអ្នកពិតជាចង់ដកអ្នកគ្រប់គ្រងនេះចេញមែនទេ?": "Are you sure you want to remove this manager?",
  "តើអ្នកពិតជាចង់លុបការប្រកាសនេះមែនទេ?": "Are you sure you want to delete this announcement?",
  "តើអ្នកពិតជាចង់លុបតួនាទីនេះមែនទេ?": "Are you sure you want to delete this role?",
  "តើអ្នកពិតជាចង់លុបតំណែងនេះមែនទេ?": "Are you sure you want to delete this position?",
  "តើអ្នកពិតជាចង់លុបនាយកដ្ឋាននេះមែនទេ?": "Are you sure you want to delete this department?",
  "តើអ្នកពិតជាចង់លុបបន្ទប់នេះមែនទេ?": "Are you sure you want to delete this room?",
  "តើអ្នកពិតជាចង់លុបបន្ទប់ប្រជុំនេះមែនទេ?": "Are you sure you want to delete this meeting room?",
  "តើអ្នកពិតជាចង់លុបប្រជុំនេះមែនទេ?": "Are you sure you want to delete this meeting?",
  "តើអ្នកពិតជាចង់លុបប្រភេទឯកសារនេះមែនទេ?": "Are you sure you want to delete this document type?",
  "តើអ្នកពិតជាចង់លុបមន្ត្រីកិច្ចសន្យានេះមែនទេ?": "Are you sure you want to delete this contract staff member?",
  "តើអ្នកពិតជាចង់លុបមន្ត្រីនេះមែនទេ?": "Are you sure you want to delete this staff member?",
  "តើអ្នកពិតជាចង់លុបឯកសារនេះមែនទេ?": "Are you sure you want to delete this document?",
  "តើអ្នកពិតជាចង់លុបអ្នកប្រើប្រាស់នេះមែនទេ?": "Are you sure you want to delete this user?",
  "តើអ្នកពិតជាចង់លុបអ្នករួមចំណែកនេះមែនទេ?": "Are you sure you want to remove this participant?",
  "ត្រឡប់": "Back",
  "តំណភ្ជាប់": "Link",
  "ថ្ងៃ និងម៉ោង": "Date and time",
  "ថ្ងៃ និងស្ថានភាព": "Date and status",
  "ថ្ងៃកែប្រែ": "Edited date",
  "ថ្ងៃខែឆ្នាំកំណើត": "Date of birth",
  "ថ្ងៃចាប់ផ្តើម": "Start date",
  "ថ្ងៃចូលធ្វើការ": "Join date",
  "ថ្ងៃបញ្ចប់": "End date",
  "ថ្ងៃបន្ទាប់": "Next day",
  "ថ្ងៃប្រជុំ": "Meeting date",
  "ថ្ងៃមុន": "Previous day",
  "ទាញយករូបភាព": "Download image",
  "ទីកន្លែងកំណើត": "Place of birth",
  "ទីតាំងបន្ទប់": "Room location",
  "ទុកទទេ ដើម្បីទាញយកទិន្នន័យទាំងអស់": "Leave blank to export all data",
  "ទំនេរ": "Available",
  "ធ្វើការសម្រេច": "Decide",
  "ធ្វើជាអ្នកគ្រប់គ្រងចម្បង": "Set as primary manager",
  "ធ្វើឱ្យសកម្ម": "Activate",
  "នាក់": "people",
  "នាយកដ្ឋានទាំងអស់": "All departments",
  "បង្កើតការជូនដំណឹង": "Create notification",
  "បង្កើតនៅ": "Created at",
  "បង្ហាញតែសកម្មភាពរបស់ខ្ញុំ": "Show only my activity",
  "បញ្ចូលការពិពណ៌នា": "Enter a description",
  "បញ្ចូលឈ្មោះតួនាទី": "Enter role name",
  "បញ្ចូលមូលហេតុ ឬ ព័ត៌មានបន្ថែម (ស្រេចចិត្ត)...": "Enter a reason or extra info (optional)...",
  "បញ្ចូលមូលហេតុ ឬ មតិបន្ថែម (ស្រេចចិត្ត)...": "Enter a reason or comment (optional)...",
  "បញ្ចូលមូលហេតុ ឬ មតិបន្ថែម...": "Enter a reason or comment...",
  "បញ្ជាក់ពាក្យសម្ងាត់ថ្មី": "Confirm new password",
  "បញ្ជាក់ម្តងទៀត...": "Confirm again...",
  "បញ្ជីការងារត្រូវអនុវត្ត...": "List of tasks to carry out...",
  "បដិសេធ": "Reject",
  "បន្ថែមតួនាទីអ្នកប្រើប្រាស់": "Add user role",
  "បន្ថែមអ្នកគ្រប់គ្រង": "Add manager",
  "បន្ថែមអ្នកគ្រប់គ្រងបានជោគជ័យ!": "Manager added successfully!",
  "បន្ថែមអ្នករួមចំណែក": "Add participant",
  "បន្ទប់": "Room",
  "បន្ទប់ / ម៉ោង": "Room / time",
  "បន្ទប់នេះត្រូវបានកក់រួចហើយក្នុងម៉ោងនេះ": "This room is already booked at this time",
  "បន្ទប់ប្រជុំ (ចុច ឬអូសលើម៉ោងទំនេរ ដើម្បីជ្រើសរើសបន្ទប់ និងម៉ោង)": "Meeting room (click or drag over an open slot to pick a room and time)",
  "បន្ទប់សរុប": "Total rooms",
  "បព្វជិត": "Monk",
  "បរិញ្ញាបត្រ...": "Bachelor's degree...",
  "បានសម្គាល់ថាអានទាំងអស់!": "Marked all as read!",
  "បានអនុម័ត": "Approved",
  "បានអាន": "Read",
  "បើកដំណើរការ": "Enable",
  "ប្រភេទការជូនដំណឹង": "Notification type",
  "ប្រភេទទិន្នន័យ": "Data type",
  "ប្រភេទទិន្នន័យទាំងអស់": "All data types",
  "ប្រភេទប្រជុំ": "Meeting type",
  "ប្រភេទអ្នកប្រើ": "User type",
  "ប្រុស": "Male",
  "បំពេញព័ត៌មានកិច្ចប្រជុំ": "Fill in the meeting details",
  "បំពេញព័ត៌មានខាងក្រោម": "Fill in the information below",
  "ផុតកំណត់ក្នុងរយៈ": "Expiring within",
  "ផ្ញើ": "Send",
  "ផ្ញើទៅអ្នកប្រើដែលបានជ្រើសរើស": "Send to selected users",
  "ផ្ទុកឡើងវិញ": "Reload",
  "ផ្លាស់ប្តូរ": "Change",
  "ផ្លូវ": "Street",
  "ផ្អាកដំណើរការ": "Deactivate",
  "ពាក្យសម្ងាត់ត្រូវបានផ្លាស់ប្តូររួចហើយ!": "Password changed successfully!",
  "ពាក្យសម្ងាត់ថ្មី": "New password",
  "ពាក្យសម្ងាត់ថ្មី...": "New password...",
  "ពាក្យសម្ងាត់ថ្មីមិនត្រូវគ្នា": "New passwords don't match",
  "ពាក្យសម្ងាត់ថ្មីមិនទាន់គ្រប់លក្ខខណ្ឌ": "The new password doesn't meet the requirements",
  "ពាក្យសម្ងាត់បច្ចុប្បន្ន": "Current password",
  "ពាក្យសម្ងាត់បច្ចុប្បន្ន...": "Current password...",
  "ពិពណ៌នា": "Description",
  "ពិពណ៌នា...": "Description...",
  "ពិពណ៌នាអំពីតួនាទី និងមុខងារ...": "Describe the role and its function...",
  "ពិពណ៌នាអំពីភារកិច្ច...": "Describe the responsibilities...",
  "ពីថ្ងៃ": "From date",
  "ព័ត៌មានការងារ": "Work information",
  "ព័ត៌មានការស្នើសុំ": "Request information",
  "ព័ត៌មានគណនី": "Account information",
  "ព័ត៌មានតំណែង": "Position information",
  "ព័ត៌មានទំនាក់ទំនង": "Contact information",
  "ព័ត៌មានបន្ថែម ឬ កំណត់សម្គាល់...": "Additional information or remarks...",
  "ព័ត៌មានបន្ទប់": "Room information",
  "ព័ត៌មានប្រព័ន្ធ": "System information",
  "ព័ត៌មានលម្អិត": "Details",
  "ព័ត៌មានលម្អិត (Details)": "Details",
  "ព័ត៌មានសង្ខេប": "Summary",
  "ព័ត៌មានសារ": "Message details",
  "ព័ត៌មានឯកសារ": "Document information",
  "ព័ត៌មានអត្តសញ្ញាណ": "Identity information",
  "ព័ត៌មានអ្នកប្រើ": "User information",
  "ភេទ/ព្រះនាម": "Gender/Title",
  "ភេទ/ព្រះនាម &nbsp;|&nbsp; តួនាទី &nbsp;|&nbsp; វត្តមាន": "Gender/Title &nbsp;|&nbsp; Role &nbsp;|&nbsp; Attendance",
  "ភ្ជាប់មន្ត្រី": "Link to staff",
  "ភ្ជាប់មន្ត្រីកិច្ចសន្យា": "Link to contract staff",
  "មតិយោបល់": "Comment",
  "មតិយោបល់ (comment)": "Comment",
  "មន្ត្រី (OFFICER)": "Staff (OFFICER)",
  "មន្ត្រីកិច្ចសន្យា (CONTRACT_OFFICER)": "Contract staff (CONTRACT_OFFICER)",
  "មានបញ្ហា": "Something went wrong",
  "មានឯកសារភ្ជាប់រួចហើយ": "A file is already attached",
  "មិនដំណើរការ": "Inactive",
  "មិនទាន់មានកំណត់ហេតុប្រជុំ": "No meeting minutes yet",
  "មិនមានទិន្នន័យ": "No data",
  "មិនមានលទ្ធផល": "No results",
  "មិនអាចកក់បាន": "Not bookable",
  "មុខងារការងារ": "Job function",
  "មើលព័ត៌មាន": "View details",
  "មើលលម្អិត": "View details",
  "រកមិនឃើញកិច្ចប្រជុំ": "No meetings found",
  "រកមិនឃើញអ្នកប្រើប្រាស់": "No users found",
  "រកមិនឃើញ": "Not found",
  "រកមិនឃើញនាយកដ្ឋាន": "No departments found",
  "រក្សាទុកកំណត់ហេតុបានជោគជ័យ!": "Minutes saved successfully!",
  "រក្សាទុករួចហើយ!": "Saved!",
  "រក្សាទុកសិទ្ធិបានជោគជ័យ!": "Permissions saved successfully!",
  "រង់ចាំ": "Waiting",
  "របស់ខ្ញុំ": "Mine",
  "រូបភាពបន្ទប់": "Room photo",
  "រូបភាពប្រវត្តិរូប": "Profile photo",
  "លុបការប្រកាសបានជោគជ័យ!": "Announcement deleted successfully!",
  "លុបជម្រើស": "Clear selection",
  "លុបតម្រង": "Clear filter",
  "លុបតួនាទីបានជោគជ័យ!": "Role deleted successfully!",
  "លុបតំណែងបានជោគជ័យ!": "Position deleted successfully!",
  "លុបនាយកដ្ឋានបានជោគជ័យ!": "Department deleted successfully!",
  "លុបបន្ទប់បានជោគជ័យ!": "Room deleted successfully!",
  "លុបបន្ទប់ប្រជុំបានជោគជ័យ!": "Meeting room deleted successfully!",
  "លុបប្រជុំ": "Delete meeting",
  "លុបប្រជុំបានជោគជ័យ!": "Meeting deleted successfully!",
  "លុបប្រភេទឯកសារបានជោគជ័យ!": "Document type deleted successfully!",
  "លុបមន្ត្រីកិច្ចសន្យាបានជោគជ័យ!": "Contract staff member deleted successfully!",
  "លុបមន្ត្រីបានជោគជ័យ!": "Staff member deleted successfully!",
  "លុបរូបភាព": "Remove image",
  "លុបឯកសារបានជោគជ័យ!": "Document deleted successfully!",
  "លុបអ្នកប្រើប្រាស់បានជោគជ័យ!": "User deleted successfully!",
  "លុបអ្នករួមចំណែកបានជោគជ័យ!": "Participant removed successfully!",
  "លេខ ផ្លូវ ភូមិ ឃុំ ស្រុក ខេត្ត": "House no., street, village, commune, district, province",
  "លេខការអនុម័ត": "Approval number",
  "លេខកូដគណនេយ្យ": "Accounting code",
  "លេខកូដមន្ត្រី": "Staff code",
  "លេខកូដមន្ត្រីកិច្ចសន្យា": "Contract staff code",
  "លេខយោង (referenceId)": "Reference ID",
  "លេខសម្គាល់": "ID",
  "លេខអ្នកប្រើ": "User ID",
  "វត្តមាន": "Attendance",
  "វាយដើម្បីស្វែងរក...": "Type to search...",
  "សកម្មភាពទាំងអស់": "All activities",
  "សង្ខេបដំណើរការ និងចំណុចសំខាន់ៗ...": "Summary of proceedings and key points...",
  "សម្រេច": "Decide",
  "សម្រេចការអនុម័ត": "Decide on approval",
  "សរុប:": "Total:",
  "សូមជ្រើសរើសតួនាទី": "Please select a role",
  "សូមជ្រើសរើសតំណែង": "Please select a position",
  "សូមជ្រើសរើសថ្ងៃប្រជុំជាមុន ដើម្បីមើលបន្ទប់ទំនេរ": "Please select the meeting date first to see available rooms",
  "សូមជ្រើសរើសនាយកដ្ឋាន": "Please select a department",
  "សូមជ្រើសរើសនាយកដ្ឋានជាមុនសិន ដើម្បីមើលអ្នកគ្រប់គ្រង": "Please select a department first to see its managers",
  "សូមជ្រើសរើសបន្ទប់ និងម៉ោង ដោយចុច ឬអូសលើតារាងបន្ទប់ទំនេរជាមុនសិន": "Please select a room and time by clicking or dragging on the availability grid first",
  "សូមជ្រើសរើសប្រភេទឯកសារ": "Please select a document type",
  "សូមជ្រើសរើសភេទ": "Please select a gender",
  "សូមជ្រើសរើសសស្ថានភាព": "Please select a status",
  "សូមជ្រើសរើសស្ថានភាព": "Please select a status",
  "សូមជ្រើសរើសអ្នកប្រើប្រាស់យ៉ាងតិចម្នាក់": "Please select at least one user",
  "សូមបញ្ចូលចំណងជើង": "Please enter a title",
  "សូមបញ្ចូលឈ្មោះខ្មែរ": "Please enter the Khmer name",
  "សូមបញ្ចូលឈ្មោះតួនាទី": "Please enter the role name",
  "សូមបញ្ចូលឈ្មោះពេញ": "Please enter the full name",
  "សូមបញ្ចូលឈ្មោះឯកសារ": "Please enter the document name",
  "សូមបញ្ចូលថ្ងៃចូលធ្វើការ": "Please enter the join date",
  "សូមបញ្ចូលពាក្យសម្ងាត់": "Please enter a password",
  "សូមបញ្ចូលលេខទូរស័ព្ទ": "Please enter a phone number",
  "សូមបញ្ចូលអ៊ីមែល": "Please enter an email",
  "សូមបំពេញពាក្យសម្ងាត់ទាំងអស់": "Please fill in all password fields",
  "សេចក្តីសង្ខេប": "Summary",
  "សេចក្តីសម្រេច": "Decisions",
  "ស្ថានភាពទាំងអស់": "All statuses",
  "ស្ថានភាពស្នាក់នៅ": "Residency status",
  "ស្នើសុំ": "Request",
  "ស្នើសុំការអនុម័ត": "Request approval",
  "ស្នើសុំអនុម័តបានជោគជ័យ!": "Approval requested successfully!",
  "ស្រី": "Female",
  "ស្វែករក.....": "Search.....",
  "ស្វែងរក ឈ្មោះ អ៊ីមែល...": "Search name, email...",
  "ស្វែងរក...": "Search...",
  "ស្វែងរក....": "Search....",
  "ស្វែងរក: អ្នកប្រើ, Entity Type....": "Search: user, entity type....",
  "ស្វែងរកឈ្មោះ ឬ លេខ....": "Search name or number....",
  "ស្វែងរកឈ្មោះ ឬ លេខឯកសារ...": "Search name or document number...",
  "ស្វែងរកឈ្មោះ, អ៊ីមែល ឬ កូដ...": "Search name, email, or code...",
  "ស្វែងរកតាមឈ្មោះ តួនាទី ឬអ៊ីមែល...": "Search by name, role, or email...",
  "ស្វែងរកតំណែង....": "Search positions....",
  "ស្វែងរកនាយកដ្ឋាន....": "Search departments....",
  "ស្វែងរកបន្ទប់....": "Search rooms....",
  "ស្វែងរកប្រជុំ....": "Search meetings....",
  "ស្វែងរកប្រភេទ...": "Search type...",
  "ស្វែងរកលេខ ឬ ទីតាំងបន្ទប់...": "Search room number or location...",
  "ស្វែងរកសិទ្ធិ...": "Search permissions...",
  "ស្វែងរកសិទ្ធិ....": "Search permissions....",
  "ស្វែងរកអ្នកប្រើ...": "Search users...",
  "ឧ. A101": "e.g. A101",
  "ឧ. ACC-001": "e.g. ACC-001",
  "ឧ. CON-001": "e.g. CON-001",
  "ឧ. DIR, MGR, SEC...": "e.g. DIR, MGR, SEC...",
  "ឧ. DM101": "e.g. DM101",
  "ឧ. IT, HR, FIN...": "e.g. IT, HR, FIN...",
  "ឧ. Junior, Senior, Manager...": "e.g. Junior, Senior, Manager...",
  "ឧ. OFC-001": "e.g. OFC-001",
  "ឧ. ចាន់ ដារ៉ា": "e.g. Chan Dara",
  "ឧ. នាយកដ្ឋានព័ត៌មានវិទ្យា...": "e.g. IT Department...",
  "ឧ. អគ្គនាយក, ប្រធាន...": "e.g. Director-General, Chief...",
  "ឯកទេស": "Specialty",
  "ឯកសារ (document_id)": "Document (document_id)",
  "ឯកសារភ្ជាប់": "Attachment",
  "អត្រាការអាន": "Read rate",
  "អនុម័តដោយ": "Approved by",
  "អាចជ្រើសរើសបានច្រើននាក់ក្នុងពេលតែមួយ": "Multiple people can be selected at once",
  "អាសយដ្ឋានបច្ចុប្បន្ន": "Current address",
  "អ្នកចូលរួមអតិបរមា": "Max participants",
  "អ្នកទទួលសរុប": "Total recipients",
  "អ្នកនឹងទទួលច្បាប់ចម្លងមួយ ដើម្បីមើលឃើញក្នុងបញ្ជីរបស់អ្នក។": "You will receive a copy so it shows up in your own list.",
  "អ្នកបញ្ជូលឯកសារ": "Uploaded by",
  "អ្នកបានអាន": "You have read",
  "អ្នកប្រើ": "User",
  "អ្នករួមចំណែក (ជ្រើសរើសមន្ត្រីដើម្បីអញ្ជើញ)": "Participants (select staff to invite)",
  "អ្នករួមចំណែកអាចគ្រប់គ្រងបាននៅក្នុងផ្ទាំង «អ្នករួមចំណែក» របស់កិច្ចប្រជុំ": "Participants can be managed from the meeting's \"Participants\" tab",
  "អ្នករៀបចំ": "Organizer",
  "អ្វីដែលបានសម្រេចក្នុងកិច្ចប្រជុំ...": "What was decided in the meeting...",

  // --- Reports.js export column headers (KH_COL) ---
  "កូដស្ថានភាព": "Status code",
  "កាលបរិច្ឆេទបង្កើត": "Created date",
  "ឈ្មោះអ្នកប្រើ (ខ្មែរ)": "User name (Khmer)",
  "ឈ្មោះអ្នកប្រើ (អង់គ្លេស)": "User name (English)",
  "ឈ្មោះមន្ត្រី": "Staff name",
  "ចូលប្រើចុងក្រោយ": "Last login",
  "កូដមន្ត្រី": "Staff code",
  "កូដមន្ត្រីកិច្ចសន្យា": "Contract staff code",
  "ឈ្មោះ (ខ្មែរ)": "Name (Khmer)",
  "ឈ្មោះ (អង់គ្លេស)": "Name (English)",
  "អាយុ": "Age",
  "មុខតំណែង": "Position",
  "ថ្ងៃចូលបម្រើការ": "Join date",
  "កម្រិតការងារ": "Job level",
  "កូដគណនេយ្យ": "Accounting code",
  "ថ្ងៃនៅសល់": "Days remaining",
  "ស្ថានភាពផុតកំណត់": "Expiry status",
  "កំណត់ចំណាំ": "Note",
  "អ៊ីមែលអ្នកទទួល": "Recipient email",
  "កូដប្រភេទ": "Type code",
  "ពេលអាន": "Read at",
  "ចំណងជើងប្រកាស": "Announcement title",
  "ម៉ោងចាប់ផ្តើម": "Start time",
  "ម៉ោងបញ្ចប់": "End time",
  "អ្នករួមចំណែកសរុប": "Total participants",
  "ចំនួនវត្តមាន": "Attended count",
  "ចំនួនអវត្តមាន": "Absent count",
  "លេខប្រជុំ": "Meeting ID",
  "កត់ត្រាដោយ": "Recorded by",
  "មានឯកសារភ្ជាប់": "Has attachment",
  "ឈ្មោះអ្នកប្រើ": "User name",
  "បញ្ចូលដោយ": "Uploaded by",
  "អ្នកស្នើសុំ": "Requested by",
  "នាយកដ្ឋានអ្នកស្នើសុំ": "Requester's department",
  "ពេលស្នើសុំ": "Requested at",
  "ពេលសម្រេច": "Decided at",
  "អ៊ីមែលអ្នកប្រើ": "User email",
  "កូដសកម្មភាព": "Action code",
  "លេខទិន្នន័យ": "Entity ID",
  "អាសយដ្ឋាន IP": "IP address",
  "នាយកដ្ឋានអ្នកបង្កើត": "Creator's department",
  "កូដអាទិភាព": "Priority code",
  "ពេលផ្សព្វផ្សាយ": "Published at",
  "ពេលផុតកំណត់": "Expires at",
  "ចំនួនបានអាន": "Read count",
  "ចំនួនមិនទាន់អាន": "Unread count",
  "អត្រាអាន": "Read rate",
  "ផ្ទាំងគ្រប់គ្រង": "Dashboard",
  "ទូទៅ": "General",
  "គ្រប់គ្រង": "Management",
  "ផ្សេងទៀត": "Other",
  "មន្ត្រី": "Staff",
  "មន្ត្រីកិច្ចសន្យា": "Contract Staff",
  "កិច្ចសន្យា": "contracts",
  "ជិតផុតកំណត់": "Expiring soon",
  "ក្នុង ៣០ ថ្ងៃ": "Within 30 days",
  "មិនទាន់អាន": "Unread",
  "ឯកសារ": "Documents",
  "ប្រភេទឯកសារ": "Document Types",
  "ឯកសារមន្ត្រី": "Staff Documents",
  "ការអនុម័ត": "Approvals",
  "កិច្ចប្រជុំ": "Meetings",
  "ប្រជុំ": "Meeting",
  "តារាងប្រជុំ": "Meeting Schedule",
  "បន្ទប់ប្រជុំ": "Meeting Rooms",
  "ការប្រកាស": "Announcements",
  "សេចក្តីប្រកាស": "Announcements",
  "អ្នកទទួល": "Recipients",
  "ការជូនដំណឹង": "Notifications",
  "ប្រព័ន្ធ": "System",
  "របាយការណ៍": "Reports",
  "ប្រវត្តិសកម្មភាព": "Activity Log",
  "ការកំណត់": "Settings",
  "នាយកដ្ឋាន": "Departments",
  "អ្នកគ្រប់គ្រងនាយកដ្ឋាន": "Department Managers",
  "តំណែង": "Positions",
  "អ្នកប្រើប្រាស់": "Users",
  "តួនាទី និងសិទ្ធិ": "Roles & Permissions",
  "អគ្គាធិការដ្ឋាន": "Inspectorate General",
  "ប្រព័ន្ធគ្រប់គ្រង": "Management System",
  "ប្រព័ន្ធគ្រប់គ្រងអគ្គាធិការដ្ឋាន": "Inspectorate General Management System",

  // --- Topbar ---
  "ព័ត៌មានអ្នកប្រើប្រាស់": "My Profile",
  "ប្តូរលេខសម្ងាត់": "Change Password",
  "ចាកចេញ": "Log out",
  "អានទាំងអស់": "Mark all read",
  "គ្មានការជូនដំណឹង": "No notifications",
  "កំពុងផ្ទុក...": "Loading...",
  "ប្រភេទ": "Type",
  "លេខយោង": "Reference #",
  "ថ្ងៃផ្ញើ": "Sent at",
  "បិទ": "Close",
  "កិច្ចប្រជុំ ": "Meeting",
  "ស្ថានភាព": "Status",

  // --- Shared components (shared/index.js) ---
  "មើល": "View",
  "កែប្រែ": "Edit",
  "លុប": "Delete",
  "សកម្មភាព": "Actions",
  "បញ្ជាក់ការលុប": "Confirm delete",
  "សកម្មភាពនេះមិនអាចត្រឡប់វិញបានទេ!": "This action cannot be undone!",
  "ជ្រើសរើស...": "Select...",
  "ជួរដេកក្នុងមួយទំព័រ": "Rows per page",
  "លទ្ធផល": "results",
  "នៃ": "of",
  "និង": "and",
  "យ៉ាងហោចណាស់ ៨ តួអក្សរ": "at least 8 characters",
  "អក្សរធំ": "an uppercase letter",
  "អក្សរតូច": "a lowercase letter",
  "លេខ (0-9)": "a number",
  "លេខ": "No.",
  "និមិត្តសញ្ញាពិសេស (ឧទាហរណ៍៖ @, #, $, %)": "a special character (e.g. @, #, $, %)",
  "ពាក្យសម្ងាត់ត្រូវមាន": "Password must contain ",
  "មានបញ្ហាមិនស្គាល់ — សូមព្យាយាមម្តងទៀត": "An unknown error occurred — please try again",

  // --- Common actions / buttons used across many pages ---
  "រក្សាទុក": "Save",
  "បោះបង់": "Cancel",
  "កំពុងរក្សាទុក...": "Saving...",
  "បន្ថែម": "Add",
  "ស្វែងរក": "Search",
  "ជ្រើសរើសទាំងអស់": "Select all",
  "ទាំងអស់": "All",
  "សរុប": "Total",
  "ថ្ងៃនេះ": "Today",
  "ថ្ងៃស្អែក": "Tomorrow",
  "ម្សិលមិញ": "Yesterday",
  "អាទិត្យ": "Sunday",
  "ចន្ទ": "Monday",
  "អង្គារ": "Tuesday",
  "ពុធ": "Wednesday",
  "ព្រហស្បតិ៍": "Thursday",
  "សុក្រ": "Friday",
  "សៅរ៍": "Saturday",
  "គ្មានទិន្នន័យ": "No data",
  "គ្មានលទ្ធផល": "No results",

  // --- Statuses
  "សកម្ម": "Active",
  "អសកម្ម": "Inactive",
  "កំពុងបម្រើការ": "Active",
  "ចូលប្រើបាន": "Valid",
  "ដំណើរការ": "Active",
  "សាកល្បង": "Trial",
  "តាមកំណត់ពេល": "Scheduled",
  "កំពុងប្រជុំ": "In progress",
  "កំណត់ហើយ": "Scheduled",
  "ពន្យារពេល": "Postponed",
  "សេចក្តីព្រាង": "Draft",
  "ត្រូវផ្ទៀងផ្ទាត់": "Pending review",
  "ឈប់សម្រាក": "On leave",
  "មិនសកម្ម": "Inactive",
  "កំពុងជួសជុល": "Under maintenance",
  "កំពុងប្រើ": "In use",
  "ផ្អាកការងារ": "Suspended",
  "ត្រូវបានបិទ": "Closed",
  "បានចាក់សោ": "Locked",
  "ផ្អាកប្លោក អាសន្ន": "Emergency suspension",
  "ចូលនិវត្តន៍": "Retired",
  "បានលាឈប់": "Resigned",
  "កិច្ចសន្យាផុត": "Contract expired",
  "កិច្ចសន្យាជិតផុត": "Contracts expiring",
  "ផុតកំណត់": "Expired",
  "បានបញ្ចប់": "Completed",
  "បិទដំណើរការ": "Deactivated",
  "បានបញ្ជាក់": "Confirmed",
  "ចាក់ឡើងវិញ": "Rescheduled",

  // --- Login page ---
  "សូមបញ្ចូលអ៊ីមែល និង ពាក្យសម្ងាត់": "Please enter your email and password",
  "ចូលប្រព័ន្ធបរាជ័យ": "Login failed",
  "អគ្គាធិការដ្ឋានពុទ្ធិកសិក្សាជាតិ": "National Education Inspectorate",
  "ចូលប្រើប្រាស់ប្រព័ន្ធ": "Sign in",
  "អ៊ីមែល *": "Email *",
  "លេខសម្ងាត់ *": "Password *",
  "កំពុងចូល...": "Signing in...",
  "ចូលប្រើប្រាស់": "Sign in",

  // --- Table columns / common field labels (Users, Staff, ContractOfficer,
  // Documents, Announcements, Approvals, Notifications, Roles, Settings, Rooms) ---
  "approval_id": "Approval ID",
  "ការពិពណ៌នា": "Description",
  "កូដ": "Code",
  "ក្រុម": "Group",
  "ចាប់ផ្តើម": "Start",
  "ចូលចុងក្រោយ": "Last login",
  "ចំណងជើង": "Title",
  "ចំនួន (នាក់)": "Capacity",
  "ឈ្មោះ": "Name",
  "ឈ្មោះ (EN)": "Name (EN)",
  "ឈ្មោះខ្មែរ": "Khmer name",
  "ឈ្មោះតួនាទី": "Role name",
  "ឈ្មោះតំណែង": "Position name",
  "ឈ្មោះនាយកដ្ឋាន": "Department name",
  "ឈ្មោះប្រភេទឯកសារ": "Document type name",
  "ឈ្មោះសិទ្ធិ": "Permission name",
  "ឈ្មោះឯកសារ": "Document name",
  "ឈ្មោះអង់គ្លេស": "English name",
  "ឈ្មោះអ្នកទទួល": "Recipient name",
  "តួនាទី": "Role",
  "ថ្ងៃ": "Date",
  "ថ្ងៃចូលការ": "Join date",
  "ថ្ងៃបង្កើត": "Created date",
  "ថ្ងៃបញ្ចូល": "Added date",
  "ថ្ងៃផុតកំណត់": "Expiry date",
  "ថ្ងៃផ្សព្វផ្សាយ": "Publish date",
  "ថ្ងៃស្នើ": "Requested date",
  "ថ្ងៃអនុម័ត": "Approved date",
  "ថ្ងៃអាន": "Read date",
  "ទីតាំង": "Location",
  "ទូរស័ព្ទ": "Phone",
  "បង្កើតដោយ": "Created by",
  "បញ្ចប់": "End",
  "ប្រជុំថ្ងៃនេះ": "Today's meetings",
  "ភេទ": "Gender",
  "មន្ត្រីសរុប": "Total staff",
  "ម្ចាស់": "Owner",
  "រូបភាព": "Photo",
  "ល.រ": "No.",
  "លេខកូដប្រភេទឯកសារ": "Document type code",
  "លេខបន្ទប់": "Room number",
  "លេខឯកសារ": "Document number",
  "លេខអនុម័ត": "Approval number",
  "សារ": "Message",
  "សិទ្ធិ": "Permissions",
  "ស្ថានភាពអាន": "Read status",
  "ស្នើដោយ": "Requested by",
  "ស្លាកឈ្មោះ": "Display name",
  "ឯកសារជិតផុត": "Documents expiring",
  "អ៊ីមែល": "Email",
  "អាទិភាព": "Priority",
  "អ្នកអនុម័ត": "Approved by",

  // --- Dashboard ---
  "មើលទាំងអស់": "View all",
  "គ្មានប្រជុំ": "No meetings",
  "គ្មានការប្រកាស": "No announcements",
  "សេចក្តីប្រកាសថ្មី": "Latest announcements",
  "សកម្មភាពរហ័ស": "Quick actions",
  "សង្ខេបស្ថានភាព": "Status summary",
  "បន្ថែមមន្ត្រី": "Add staff",
  "បន្ថែមប្រជុំ": "Add meeting",
  "អនុម័ត": "Approve",
  "ទាប": "Low",
  "មធ្យម": "Medium",
  "ខ្ពស់": "High",
  "បន្ទាន់": "Urgent",
  "ពន្យារ": "Postponed",

  // --- Notifications page ---
  "ការជូនដំណឹងសរុប": "Total notifications",
  "មិនទាន់ឃើញ": "Not seen",
  "បានឃើញ": "Seen",
  "កំពុងបង្ហាញ": "Showing",
  "ស្វែងរកចំណងជើង ឬ សារ...": "Search title or message...",
  "បង្កើត និងផ្ញើ": "Create & send",
};
